import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

export const getPatientReport = (routeName, receptionCode, callback) => {
    cachiosInstance.get(`/${routeName}/patientReport/${receptionCode}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error.response.data);
        })
};
export const getDoctorPatients = (routeName,medDoctor, secDoctor, fromDate, toDate, callback) => {
    cachiosInstance.get(`/${routeName}/doctorPatients/${medDoctor}/${secDoctor}${fromDate && toDate ? `?fromDate=${fromDate}&toDate=${toDate}` : ""}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error.response.data);
        })
};
export const getArefToken = (callback) => {
    cachiosInstance.get(`/aref/token`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error.response.data);
        })
};
export const getTokenInformation = (token, callback) => {
    cachiosInstance.get(`/departments/general-token/${token}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error.response.data);
        })
};
export const getDoctorInformation = (routeName,medicalCouncil, callback) => {
    cachiosInstance.get(`/${routeName}/doctorInformation/${medicalCouncil}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error.response.data);
        })
};
export const getMEDRequestGroup = (routeName,callback) => {
    cachiosInstance.get(`/${routeName}/MEDRequestGroup`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error.response.data);
        })
};